module.exports = __webpack_public_path__ + "img/icon_setting_off.0098c9b9.svg";